import React, { FC } from 'react'

import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { ModalType } from 'src/Types/ui'

import { LanguagesModalSpotifyWrapper } from './LanguagesModalSpotifyWrapper'
import { GenresModalsWrapper } from './GenresModalsWrapper'
import { TrackNoteModalWrapper } from './TrackNoteModalWrapper'
import { AiUsageModal } from './AiUsageModal'
import { TrackFileModal } from './TrackFileModal'
import { ReleaseDateModal } from './ReleaseDateModal'

export const SpotifyScheduleModals: FC = () => {
  const { search } = useCustomSearchParams()

  if (search.get('modal') === ModalType.Genres) {
    return <GenresModalsWrapper />
  }
  if (search.get('modal') === ModalType.Languages) {
    return <LanguagesModalSpotifyWrapper />
  }
  if (search.get('modal') === ModalType.Comment) {
    return <TrackNoteModalWrapper />
  }
  if (search.get('modal') === ModalType.AiUsage) {
    return <AiUsageModal />
  }
  if (search.get('modal') === ModalType.TrackFile) {
    return <TrackFileModal />
  }
  if (search.get('modal') === ModalType.ReleaseDate) {
    return <ReleaseDateModal />
  }
  return null
}
